const translation = {
  routesGroup: {
    home: 'Home',
    iaas: 'IaaS',
    containerService: 'Container Service',
    ai: 'AI',
    others: 'Others',
    systemSetting: 'Site Settings',
  },
  // routes title keys
  dashboard: 'Dashboard',
  compute: 'Compute',
  instancesAndImages: 'Instances & Images',
  vm: 'VM Instance',
  baremetal: 'Bare Metal',
  instanceGroup: 'Instance Group',
  serverTemplate: 'Server Template',
  scalingGroup: 'Scaling Group',
  webApp: 'Web App',
  systemImage: 'System Image',
  hostImage: 'Host Image',
  storageAndBackup: 'Storage & Backup',
  disk: 'Disk',
  diskSnapshot: 'Disk Snapshot',
  instanceSnapshot: 'Instance Snapshot',
  snapshotPolicy: 'Snapshot Policy',
  diskBackup: 'Disk Backup',
  instanceBackup: 'Instance Backup',
  networkAndSecurity: 'Network & Security',
  secGroup: 'Security Group',
  subnet: 'Subnet',
  eip: 'EIP',
  tapService: 'Tap Service',
  keypair: 'Key Pair',
  resourceAndSchedule: 'Resource & Schedule',
  sku: 'SKU',
  host: 'Host',
  physicalMachine: 'Physical Machine',
  gpu: 'GPU',
  schedTag: 'Sched Tag',
  schedPolicy: 'Sched Policy',
  dynamicSchedTag: 'Dynamic Sched Tag',
  recycleBin: 'Recycle Bin',
  serverRecovery: 'Server Recovery',
  diskRecovery: 'Disk Recovery',
  imageRecovery: 'Image Recovery',
  network: 'Network',
  networkPlan: 'Network Plan',
  region: 'Region',
  zone: 'Zone',
  baseNetwork: 'Base Network',
  vpcInterconnect: 'VPC Interconnect',
  vpcPeer: 'VPC Peer',
  globalVpc: 'Global VPC',
  vpc: 'VPC',
  routeTable: 'Route Table',
  wire: 'Wire',
  networkService: 'Network Service',
  nat: 'NAT Gateway',
  dns: 'DNS',
  ipv6: 'IPv6 Gateway',
  networkSecurity: 'Network Security',
  waf: 'WAF',
  sshProxy: 'SSH Proxy',
  sshProxyNode: 'Proxy Node',
  sshProxyService: 'Proxy Service',
  lb: 'Load Balancer',
  lbInstance: 'LB Instance',
  lbAcl: 'LB ACL',
  lbCert: 'LB Certificate',
  lbCluster: 'LB Cluster',
  lbClusterMain: 'Cluster Main',
  lbClusterNode: 'Cluster Node',
  cdn: 'CDN',
  cdnDomain: 'CDN Domain',
  storage: 'Storage',
  blockStorage: 'Block Storage',
  workload: 'Workload',
  stateless: 'Stateless',
  stateful: 'Stateful',
  daemonset: 'DaemonSet',
  job: 'Job',
  cronjob: 'CronJob',
  pod: 'Pod',
  pvc: 'PVC',
  imageRepo: 'Image Repo',
  serviceDiscovery: 'Service Discovery',
  service: 'Service',
  ingress: 'Ingress',
  configManage: 'Config Manage',
  configmap: 'ConfigMap',
  secret: 'Secret',
  clusterManage: 'Cluster Manage',
  node: 'Node',
  storageClass: 'Storage Class',
  namespace: 'Namespace',
  role: 'Role',
  clusterRole: 'Cluster Role',
  roleBinding: 'Role Binding',
  clusterRoleBinding: 'Cluster Role Binding',
  serviceAccount: 'Service Account',
  kubeComponent: 'Kube Component',
  federatedCluster: 'Federated Cluster',
  federatedNamespace: 'Federated Namespace',
  federatedRole: 'Federated Role',
  federatedClusterRole: 'Federated Cluster Role',
  federatedRoleBinding: 'Federated Role Binding',
  federatedClusterRoleBinding: 'Federated Cluster Role Binding',
  ml: 'MLOps',
  dataManage: 'Data Manage',
  dataset: 'Dataset',
  diskStorage: 'Disk Storage',
  onlineDev: 'Online Dev',
  containerInstance: 'Container Instance',
  containerImage: 'Container Image',
  repository: 'Repository',
  modelManage: 'Model Management',
  modelList: 'Model List',
  modelTrain: 'Model Train',
  trainTask: 'Training Task',
  trainTemplate: 'Training Template',
  modelInference: 'Model Inference',
  inferenceService: 'Inference Service',
  systemSetting: 'System Setting',
  computeCluster: 'Compute Cluster',
  storageCluster: 'Storage Cluster',
  resourceQuota: 'Resource Quota',
  auditLog: 'Audit Log',
  aiAppBuild: 'AI App Build',
  knowledgeBase: 'Knowledge Base',
  appBuild: 'App Build',
  appMarket: 'App Market',
  monitoringAndOperations: 'Monitoring & Operations',
  overview: 'Overview',
  resource: 'Resource',
  monitorVM: 'Monitor VM',
  monitorHost: 'Monitor Host',
  monitorMetric: 'Monitor Metric',
  monitorDashboard: 'Monitor Dashboard',
  monitorQuery: 'Monitor Query',
  alert: 'Alert',
  alertPolicy: 'Alert Policy',
  alertHistory: 'Alert History',
  alertResource: 'Alert Resource',
  alertPolicy2: 'Resource Alert Policy',
  authenticationAndSecurity: 'Authentication & Security',
  authSystem: 'Auth System',
  authIdp: 'Authentication Domain',
  authDomain: 'Domain',
  authProject: 'Auth Project',
  authGroup: 'Auth Group',
  authUser: 'Auth User',
  authRole: 'Auth Role',
  authPolicy: 'Auth Policy',
  securityAlert: 'Security Alert',
  messageCenter: 'Message Center',
  messageSubscribeSetting: 'Message Subscribe Setting',
  notifyChannelSetting: 'Notify Channel Setting',
  contactManage: 'Contact Manage',
  robotManage: 'Robot Manage',
  systemSetting2: 'System Setting',
  websiteSetting: 'Website Setting',
  licenseSetting: 'License Setting',
}
export default translation;